import React, { useContext, useState } from "react";
import { TextField, Button, Grid, Typography } from "@mui/material";
import SendIcon from "@mui/icons-material/Send";
import styles from "./sign.module.css";
import { useNavigate } from "react-router-dom";
import apiClient from "../../api/Api.js";
import { DataContext } from "../../context/dataprovider.js"; // Import the context
import { toast } from "react-toastify";
function SignIn() {
  const navigate = useNavigate();
  const { fetchData, userData, role } = useContext(DataContext); // Use the context
  const AUTH_API = process.env.REACT_APP_AUTH_API;
  const [data, setData] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false); // Track loading state
  const [error, setError] = useState(""); // Store error message

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { email, password } = data;

    if (!email || !password) {
      setError("Please fill in all the details.");
      return;
    }

    setLoading(true); // Start loading
    setError(""); // Clear previous errors

    try {
      const response = await apiClient.post(`/${AUTH_API}/login`, {
        email,
        password,
      });
      if (response.status === 201) {
        toast.error(response.data.message, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        localStorage.clear();
        return;
      }

      const { email: userEmail } = response.data;

      // Save user info to local storage
      localStorage.setItem("clientId", userEmail);

      // Fetch user-specific data from the backend
      console.log(`Fetching data for user: ${userEmail}`);

      const responce = await fetchData(userEmail);

      if (responce.status === 201) {
        localStorage.clear();

        toast.error(responce.data.message, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        navigate("/");
        return;
      }
      setTimeout(() => {
        if (responce.status === 200) {
          toast.success("Login Success", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          if (userData.role === role.roles_6) {
            navigate("/administrator-dashboard");
          } else {
            navigate("/transactions");
          }
        }
      }, 500);
      // Navigate to dashboard on success
    } catch (err) {
      toast.error("Server Busy", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      localStorage.clear();
      console.error(err);
      setError(
        err.response?.data?.message || "An error occurred during sign-in."
      );
    } finally {
      setLoading(false); // Stop loading
    }
  };

  const handleChange = (e) => {
    setData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  return (
    <div className={styles.container}>
      <form onSubmit={handleSubmit} className={styles.formContainer}>
        <Typography variant="h6" gutterBottom>
          Sign In
        </Typography>

        {error && (
          <Typography color="error" variant="body2">
            {error}
          </Typography>
        )}

        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              id="email"
              name="email"
              label="Email"
              variant="outlined"
              fullWidth
              value={data.email}
              onChange={handleChange}
              required
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              id="password"
              name="password"
              label="Password"
              type="password"
              variant="outlined"
              fullWidth
              value={data.password}
              onChange={handleChange}
              required
            />
          </Grid>
          <Grid item xs={12}>
            <Button
              type="submit"
              variant="contained"
              fullWidth
              endIcon={<SendIcon />}
              disabled={loading} // Disable button while loading
            >
              {loading ? "Signing In..." : "Sign In"}
            </Button>
          </Grid>
        </Grid>
      </form>
    </div>
  );
}

export default SignIn;
